import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getUserRoutes } from 'router/routes'
import NotFound from 'pages/not_found/NotFound'

const RouteAccessGuard = () => {
  const location = useLocation()
  const { user } = useSelector(state => state.user.auth)
  const userRoutes = getUserRoutes(user.menus)
  const hasAccess = userRoutes.some(route => location.pathname.startsWith(route))

  return hasAccess ? <Outlet /> : <NotFound />
}

export default RouteAccessGuard